import { Link } from "react-router";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components/ui/page";

export function NotFoundPage() {
  const { t } = useTranslation("pages");

  return (
    <>
      <PageHeader title={t("notFoundTitle")} description={t("notFoundDescription")} />
      <Link to="/dashboard" className="text-sm text-brand-strong underline underline-offset-2">
        Go to the dashboard
      </Link>
    </>
  );
}
